import ModalAnalisar from "../../../components/Previa/ModalAnalisar";
import { usePreviaIcms } from "../PreviaIcmsContext";

const ModalAnalisarIcms = ({ open, setOpen, isTab }) => {
  return (
    <ModalAnalisar
      open={open}
      setOpen={setOpen}
      isTab={isTab}
      tipoPrevia="ICMS"
      contextHook={usePreviaIcms}
    />
  );
};

export default ModalAnalisarIcms;
